export default "__VITE_ASSET__rc9cvTeC__"